// Product Tabs

$(document).ready(function () {
  $('.tab_content').first().show();
  $('.tab_buttons button').first().addClass('active');
  $('.tab_buttons button').on('click', function () {
    var selectedTab = $(this).data('tab');
    $('.tab_buttons button').removeClass('active');
    $(this).addClass('active');
    $('.tab_content').hide();
    $('.tab_content[data-tab="' + selectedTab + '"]').show();
  });
});

// Product accordion

$(document).ready(function () {
  $('.dropdown_item').first().find('.dropdown_content').show();
  $('.dropdown_item').first().find('h3').addClass('active');
  $('.dropdown_item h3').on('click', function () {
    var $content = $(this).next('.dropdown_content');
    var isOpen = $content.is(':visible');

    if (isOpen) {
      $content.slideUp(200);
      $(this).removeClass('active');
    } else {
      $content.slideDown(200);
      $(this).addClass('active');
    }
  });
});

// Junip Reviews Stars

$(document).ready(function () {
  let updateTimer;

  $('.junip-product-summary-review-count').css('display', 'none');

  function finalizeReviewCount() {
    $('.junip-product-summary-review-count').each(function () {
      const $el = $(this);
      const cleaned = $el.text().replace(/[()]/g, '').trim();
      $el.text(cleaned + ' Reviews');
      $el.css('display', 'inline');
    });
  }

  const summary = document.querySelector('.junip-product-summary');
  if (summary) {
    const observer = new MutationObserver(function () {
      clearTimeout(updateTimer);
      updateTimer = setTimeout(function () {
        finalizeReviewCount();
        observer.disconnect();
      }, 1000);
    });

    observer.observe(summary, {
      childList: true,
      subtree: true,
    });
  }
});

// Product form Spinner

$(".preorder_button").click(function(){
  const $btn = $(this);
  $btn.find('span').hide();
  $btn.find('.spinner').show();

  setTimeout(function() {
    $btn.find('span').show();
    $btn.find('.spinner').hide();
  }, 2000);
});

$(".product_add input").click(function(){
  const $input = $(this);
  $input.val('');
  $input.parent().find('.spinner').show();

  setTimeout(function() {
    $input.val('Add to Cart');
    $input.parent().find('.spinner').hide();
  }, 2000);
});

// Fixed ATC

$(document).ready(function() {
  function checkATCVisibility() {
    var standardATC = $('.atc_standard');
    var fixedATC = $('.atc_fixed');

    if (!standardATC.length) return;

    var windowTop = $(window).scrollTop();
    var windowBottom = windowTop + $(window).height();
    var atcBottom = standardATC.offset().top + standardATC.outerHeight();

    if (atcBottom < windowTop) {
      if (!fixedATC.is(':visible')) {
        fixedATC.fadeIn(200);
      }
    } else {
      if (fixedATC.is(':visible')) {
        fixedATC.fadeOut(200);
      }
    }
  }

  $(window).on('scroll resize', checkATCVisibility);
  checkATCVisibility();
});

// Check for warrantee guarantee

$('.pdp_guarantees span').each(function() {
  if ($(this).text().toLowerCase().includes('warranty')) {
    $(this).addClass('warranty_guarantee');
  }
});
